import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ExpandRightPanel extends Vue {
    get activeRightPanelKey() {
        return this.$store.state.ui.activeRightPanelKey;
    }

    expandRightPanelByKey(key) {
        if (this.activeRightPanelKey !== key) {
            this.$bus.$emit("changeRightViewActiveKey", key);
            this.$bus.$emit("changeRightView", key, false, "other");
        }
        if (key === "themeP") {
            this.$bus.$emit("changeCurrentThemeTab", "recommend");
        }
    }
}
